import { render, staticRenderFns } from "./down.vue?vue&type=template&id=dfd10504"
import script from "./down.vue?vue&type=script&lang=js"
export * from "./down.vue?vue&type=script&lang=js"
import style0 from "./down.vue?vue&type=style&index=0&id=dfd10504&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfd10504')) {
      api.createRecord('dfd10504', component.options)
    } else {
      api.reload('dfd10504', component.options)
    }
    module.hot.accept("./down.vue?vue&type=template&id=dfd10504", function () {
      api.rerender('dfd10504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vue-brower-down/down.vue"
export default component.exports